import { createContext } from 'react';
import { CampaignItemRoutes } from 'components/pages/campaign-settings/campaign-auction/useCampaignItemRoutes';
import { AuctionItem, Campaign } from 'types/domain';

interface IItemOptionsContext {
    item: AuctionItem;
    campaign: Campaign;
    routes: CampaignItemRoutes;
}

const ItemOptionsContext = createContext<IItemOptionsContext>({
    item: {} as AuctionItem,
    campaign: {} as Campaign,
    routes: {} as CampaignItemRoutes,
});

export { ItemOptionsContext };
export type { IItemOptionsContext };
